/**
 * FilterPanel — panel desplegable de filtros con diseño unificado.
 *
 * Se usa tanto en Facturas como en Recibos.
 * Los campos específicos de cada módulo se pasan como children o props.
 */
import styles from "./FilterPanel.module.css";
import { useTranslation } from "react-i18next";

export function FilterPanel({ children, onClear, activeCount = 0 }) {
  const { t } = useTranslation();
  return (
    <div className={styles.panel}>
      <div className={styles.grid}>{children}</div>
      {activeCount > 0 && (
        <div className={styles.footer}>
          <span className={styles.activeNote}>
            <i className="fa-solid fa-circle-dot" /> {activeCount} {t("common.filtrosActivos")}
          </span>
          <button className={styles.clearBtn} onClick={onClear}>
            <i className="fa-solid fa-xmark" /> {t("common.limpiarTodo")}
          </button>
        </div>
      )}
    </div>
  );
}

export function FilterField({ label, children }) {
  return (
    <div className={styles.field}>
      <label className={styles.fieldLabel}>{label}</label>
      {children}
    </div>
  );
}

export function FilterInput({ type = "text", ...props }) {
  return <input type={type} className={styles.input} {...props} />;
}

export function FilterCheckGroup({ options, selected = [], onChange }) {
  return (
    <div className={styles.checkGroup}>
      {options.map((opt) => {
        const isSelected = selected.includes(opt.value);
        return (
          <label
            key={opt.value}
            className={`${styles.checkItem} ${isSelected ? styles.checkItemActive : ""}`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => {
                const next = isSelected
                  ? selected.filter((v) => v !== opt.value)
                  : [...selected, opt.value];
                onChange(next);
              }}
              className={styles.checkInput}
            />
            <span className={styles.checkMark}>
              {isSelected && <i className="fa-solid fa-check" />}
            </span>
            <span className={styles.checkLabel}>{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
}

export function FilterDivider() {
  return <div className={styles.divider} />;
}
